import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { JwtService } from './jwt.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient) {}

  private formatErrors(error: any) {
    return throwError(error.error);
  }

  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http
      .get(`${environment.apiUrl}${path}`, { params })
      .pipe(catchError(this.formatErrors));
  }

  put(
    path: string,
    body: object = {},
    params: HttpParams = new HttpParams()
  ): Observable<any> {
    return this.http
      .put(`${environment.apiUrl}${path}`, JSON.stringify(body), { params })
      .pipe(catchError(this.formatErrors));
  }

  /**
   * PUT but without the environment API URL
   */
  putExternal(
    path: string,
    body: object = {},
    params: HttpParams = new HttpParams()
  ): Observable<any> {
    return this.http
      .put(`${path}`, JSON.stringify(body), { params })
      .pipe(catchError(this.formatErrors));
  }

  post(
    path: string,
    body: object = {},
    headerOptions?: object
  ): Observable<any> {
    return this.http
      .post(`${environment.apiUrl}${path}`, JSON.stringify(body), headerOptions)
      .pipe(catchError(this.formatErrors));
  }

  postMultipart(
    path: string,
    body: object = {},
    headerOptions?: object
  ): Observable<any> {
    return this.http
      .post(`${environment.apiUrl}${path}`, body, headerOptions)
      .pipe(catchError(this.formatErrors));
  }

  delete(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http
      .delete(`${environment.apiUrl}${path}`, { params })
      .pipe(catchError(this.formatErrors));
  }

  queryParams(queryParams: {}): HttpParams {
    let params = new HttpParams();

    Object.keys(queryParams || []).forEach((param) => {
      if (queryParams[param]?.constructor == Array) {
        queryParams[param].forEach((p) => {
          params = params.append(param, p);
        });
      } else if (queryParams[param]?.constructor == Object) {
        for (const key in queryParams[param]) {
          if (queryParams[param].hasOwnProperty(key)) {
            params = params.append(param + '.' + key, queryParams[param][key]);
          }
        }
      } else {
        params = params.append(param, queryParams[param]);
      }
    });
    return params;
  }
}
